import { gql } from '@apollo/client';

const UPDATE_APPS_ON_SITE_LEVEL = gql`
  mutation manageOperatorSiteApps($input: OperatorSiteInput!) {
    manageOperatorSiteApps(input: $input)
  }
`;

export { UPDATE_APPS_ON_SITE_LEVEL };
